<button
  type="button"
  class="select-carousel-previous__btn btn-clean"
  aria-label="Précédent"
  i18n-aria-label
  [attr.aria-controls]="id"
  (click)="doPrevious()"
  [disabled]="isFirst()"
>
  <app-svg-icon class="select-carousel-previous__icon" icon="chevron-down" width="0.75em"></app-svg-icon>
</button>

<div
  [id]="id"
  role="listbox"
  tabindex="0"
  [attr.aria-labelledby]="ariaLabelledBy"
  [attr.aria-activedescendant]="model?.id"
  (keyup.arrowleft)="doPrevious()"
  (keyup.arrowright)="doNext()"
  (swipeleft)="doNext()"
  (swiperight)="doPrevious()"
  [@slideAnimation]="model && model.id ? model.id : 'no-animation'"
>
  <ng-content></ng-content>
</div>

<button
  type="button"
  class="select-carousel-next__btn btn-clean"
  aria-label="Suivant"
  i18n-aria-label
  [attr.aria-controls]="id"
  (click)="doNext()"
  [disabled]="isLast()"
>
  <app-svg-icon class="select-carousel-next__icon" icon="chevron-down" width="0.75em"></app-svg-icon>
</button>
